<template>
  <v-data-table
    :footer-props="tableFooterProps"
    :headers="tableHeaders"
    :items="dadosRelatorio"
    :loading="loading"
    :options="{ itemsPerPage: 10 }"
    :search="search"
    no-data-text="Nenhum resultado encontrado"
  ></v-data-table>
</template>

<script>
export default {
  name: "table-vaga-integral",

  props: {
    search: {
      type: String,
      default: () => "",
    },
  },

  data: () => ({
    tab: "efetuadas",
    loading: false,
    dadosRelatorio: [],
    tableHeaders: [
      {
        text: "Protocolo",
        align: "center",
        sortable: true,
        value: "protocolo",
      },
      {
        text: "Nome",
        align: "center",
        sortable: true,
        value: "nome",
      },
    ],
    tableFooterProps: {
      "items-per-page-options": [10, 50, 100, -1],
      "items-per-page-text": "Inscrições por página",
      "page-text": "{0}-{1} de {2}",
    },
  }),

  mounted() {
    this.getCadastrosDeferidos();
  },

  methods: {
    async getCadastrosDeferidos() {
      this.loading = true;
      await this.$http
        .get("cadastros-deferidos-vaga-integral")
        .then((response) => {
          this.dadosRelatorio = response;
          this.loading = false;
        })
        .catch((error) => {
          this.showMessage(error, "error");
          this.loading = false;
        });
    },
  },
};
</script>
